import type { ReactNode } from "react";

import { Button } from "./Button";

type BuyButtonVariant = "primary" | "secondary" | "ghost" | "gold";

type BuyButtonProps = {
  href: string;
  children: ReactNode;
  variant?: BuyButtonVariant;
  className?: string;
};

export function BuyButton({
  href,
  children,
  variant = "secondary",
  className,
}: BuyButtonProps) {
  return (
    <Button href={href} variant={variant} className={className} newTab>
      {children}
    </Button>
  );
}
